module.exports = __webpack_public_path__ + "static/media/protocol.c65ccbfe.svg";